import { useState, useEffect, useRef } from "react";
import dayjs from 'dayjs';

import { Button, Form, Spin, Card, Tabs, Row, Col, Input } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined } from '@ant-design/icons';

import { apiCand } from "../../../../services/apiCand";
import { apiAuxiliar, obterCaracteristicasConselheiro } from "../../../../services/apiAuxiliar";
import { getEntidadesAtivas, hasPermissao, Papel } from "../../../../auth/entidadeUsuario";
import "../style.css";

import { IMandatoCaracteristica, IMandatoHabilitacao, IDocumentoMandato, ICaracteristicasMandato, IMandatoDirigente, IMandatoSuspensao } from "../../Componentes/InterfaceMandato";
import { ICtrlDoc } from "../../../../Interfaces/DadosPrevicInterfaces";

import CadInfoBotoes from "../../Componentes/CadInfoBotoes";
import ConselheiroPerfil from "../Componentes/ConselheiroPerfil"
import DirigenteCaracteristica from "../../Componentes/DirigenteCaracteristica";
import DirigenteHabilitacao from "../../Componentes/DirigenteHabilitacao";
import DirigenteDocumento from "../../Componentes/DirigenteDocumento";

import { resetColor } from "../../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../../utils/messages";
import { maskCpf } from "../../../../utils/maskFunctions";
import { IErroApi } from "../../../../Interfaces/Interfaces";
import PessoaFisicaDadosPessoaisComplementares from "../../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";
import { useLocation } from "react-router";
import { isAntesDoTermino, isStateValid } from "../../../../utils/utilsFunctions";
import { IAuditoria, IEntidade } from "../../../../Interfaces/DadosPrevicInterfaces";
import Auditoria from "../../../../components/Auditoria";
import InfoHistorico from "../../../../components/InfoHistorico";
import Watermark from "../../../../components/WaterMark";
import DirigenteSuspensao from "../../Componentes/DirigenteSuspensao";


const Manter = (props: any) => {
  const [form] = Form.useForm();
  const { state } = useLocation();

  const [isDirty, setIsDirty] = useState(false);
  const handlerRef = useRef<(e: BeforeUnloadEvent) => void>(null);

  const [dadosConselheiro, setDadosConselheiro] = useState<IMandatoDirigente>();
  const [mandatoCaracteristicas, setMandatoCaracteristicas] = useState<IMandatoCaracteristica[]>([]);
  const [mandatoSuspensoes, setMandatoSuspensoes] = useState<IMandatoSuspensao[]>([]);
  const [mandatoHabilitacao, setMandatoHabilitacao] = useState<IMandatoHabilitacao[]>([]);
  const [mandatoDocumentos, setMandatoDocumentos] = useState<IDocumentoMandato[]>([]);

  const [dadosAuditoria, setDadosAuditoria] = useState<IAuditoria[]>([]);
  const [registroHistorico, setRegistroHistorico] = useState<IAuditoria>();
  const [activeKey, setActiveKey] = useState('item-1');


  const [valueCategoria, setValueCategoria] = useState(2);
  const [valueCondicao, setValueCondicao] = useState(1);
  const [valueRepresentacao, setValueRepresentacao] = useState(1);


  const [manter, setManter] = useState(2); // 2 : Detalhar / 3 : Alterar;
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)

  const [entidades, setEntidades] = useState<IEntidade[]>([]);


  useEffect(() => {
    const storedHistorico = sessionStorage.getItem("registroHistorico");
    if (storedHistorico) {
      sessionStorage.removeItem("registroHistorico"); // optional: avoids reuse on refresh
      // console.log("historico");
      setManter(9);
      let storedData = JSON.parse(storedHistorico);
      // console.log(json.corpoPre);
      let obj = {
        ...JSON.parse(storedData.json.corpoPre),
        entidade: storedData.entidade
      };
      setDadosMandatoConselheiroFull(obj);
      setRegistroHistorico(storedData.json);
      mostrarInfo("Registro Histórico", "Você está agora em uma nova janela e vendo um registro histórico. Edições não estão disponíveis");
      setActiveKey('item-1');
      window.scrollTo(0, 0)
    } else if (isStateValid(state)) {
      setManter(state.manter);
      setDadosMandatoConselheiroFull(state.data);
    }

    if (ctrlDoc.length === 0) getCtrlDocCons();
    if (caracteristicasMandato.length === 0) getCaracteristicasMandato();

    // PREVINE SAIDA DA PÁGINA COM DADOS EM EDIÇÃO
    handlerRef.current = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // Still required in most browsers
    };

  }, []);

  useEffect(() => {
    if (manter === 2 && dadosConselheiro) { // SE OS DADOS DE MANDATO DE CONSELHEIRO JÁ ESTIVEREM PREENCHIDOS EXIBIR DETALHES - ESTA AÇÃO DECORRE NORMALMENTE QUANDO SE CANCELA A EDIÇÃO
      setDadosMandatoConselheiroFull(dadosConselheiro);
    }

    if (manter === 3) {
      setActiveKey('item-1');
      setIsDirty(true);
    } else setIsDirty(false);

  }, [manter]);

  useEffect(() => {
    // Verifica se existe registro histórico incompleto. Se sim, consulta o registro novamente para atualizar os dados históricos.
    // Verifica o primeiro e o último registro. Em teoria
    if (!registroHistorico && dadosAuditoria && dadosAuditoria.length > 0) {
      let size = dadosAuditoria.length;
      if (size > 0 && (
        (dadosAuditoria[0].dtPos === undefined || dadosAuditoria[0].dtPos === "")
        || (dadosAuditoria[0].eventos === undefined || dadosAuditoria[0].eventos.length === 0)
      )){
        getConselheiroPorId(dadosConselheiro?.idMandato);
      }
    }
  }, [dadosAuditoria]);

  // useEffect(() => {
  //   if (registroHistorico) { // AUDITORIA/HISTÓRICO
  //     resetForm();
  //     setDadosMandatoConselheiroFull(JSON.parse(registroHistorico.corpoPre));
  //     setManter(9);
  //     setActiveKey('item-1');
  //     window.scrollTo(0, 0)
  //     mostrarInfo("Registro Histórico", "Você está agora vendo um registro histórico. Edições não estão disponíveis");

  //   }
  // }, [registroHistorico]);

  useEffect(() => {
    if (registroHistorico && manter !== 9) { // AUDITORIA/HISTÓRICO
      // Save data in sessionStorage
      sessionStorage.setItem("registroHistorico", JSON.stringify({json: registroHistorico, entidade: dadosConselheiro?.entidade}));
      // Open new tab
      window.open("/dirigente/conselheiro/manter", "_blank");
      setActiveKey('item-1');
    }
  }, [registroHistorico]);

  const getConselheiroPorId = async (idMandato?: number) => {
    try {
      setTipLoading("Atualizando registros históricos");
      setLoading(true);

      let lQuery = `mandatoconselheiro/${idMandato}`;
      const { data } = await apiCand.get(lQuery);
      setDadosMandatoConselheiroFull(data);

    } catch (error) {
      // console.log(error);
      errorMessage("Erro ao atualizar os registros históricos");
    } finally {
      setLoading(false);
    }
  };


  // PARA USUÁRIOS ENTIDADE DESABILITA O BOTÃO EDITAR CASO situacaoVigencia === flase. EM TEORIA, SIGNIFICA QUE O REGISTRO CHEGOU AO SEU FIM E NÃO PODE MAIS SER ALTERADO.
  function desabilitaBtnEditar(title: string, msg: string) {
    if (isAntesDoTermino(dadosConselheiro?.dtFimMandato)){
      if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO])){
        return false;
      }
      if (hasPermissao([Papel.ENTIDADE_ALTERAR]) && [3, 4].includes(dadosConselheiro?.entidade?.codigoEnquadramento ?? 0) ){
        for (let ent of getEntidadesAtivas()){
          if (ent.matricula === dadosConselheiro?.entidade?.matricula){
            return false;
          }
        }
      }
    }
    return !hasPermissao([Papel.DILIC_MASTER]);
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  function setDadosMandatoConselheiroFull(manDir: IMandatoDirigente) {
    form.setFieldsValue({
      "idMandato": manDir.idMandato,
      "dtInicioMandato": manDir.dtInicioMandato ? dayjs(manDir.dtInicioMandato) : undefined,
      "dtFimMandato": manDir.dtFimMandato ? dayjs(manDir.dtFimMandato) : undefined,
      "dtInicioExercicio": manDir.dtInicioExercicio ? dayjs(manDir.dtInicioExercicio) : undefined,
      "dtFimExercicio": manDir.dtFimExercicio ? dayjs(manDir.dtFimExercicio) : undefined,

      "matriculaEfpc": manDir.entidade?.matricula ?? state.matriculaEfpc,
      "sigla": manDir.entidade?.sigla ?? '??',
      "nuCpf": maskCpf( manDir.pessoaFisica? manDir.pessoaFisica.nuCpf : state.nuCpf ),
      "nmPessoaFisica": manDir.pessoaFisica ? manDir.pessoaFisica.nmPessoaFisica : state.nmPessoaFisica,

    });

    setDadosConselheiro(manDir); // RECUPERA OS DADOS DIRETO DA BASE. ESTA ARRAY MANTÉM INTACTO OS DADOS RECEBIDOS DA BASE, QUE PODERÃO SER UTILIZADOS PARA RECUPERAR INFORMAÇÕES EM CASO DE CANCELAMENTO DE EDIÇÃO.
    if (manDir.mandatoCaracteristicas) setMandatoCaracteristicas(manDir.mandatoCaracteristicas);
    if (manDir.mandatoSuspensoes) setMandatoSuspensoes(manDir.mandatoSuspensoes);
    if (manDir.habilitacoes) setMandatoHabilitacao(manDir.habilitacoes);
    if (manDir.mandatoDocumentos) setMandatoDocumentos(manDir.mandatoDocumentos);

    if (manDir.auditoria) setDadosAuditoria(manDir.auditoria);
    // console.log(manDir);
  }

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");


  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json: IMandatoDirigente = {
      idMandato: form?.getFieldValue("idMandato"),
      idPessoaFisica: state.data.pessoaFisica.idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      csCategoria: valueCategoria, // Conselheiro 
      dtInicioMandato: form?.getFieldValue("dtInicioMandato") ? dayjs(form?.getFieldValue("dtInicioMandato")).format("YYYY-MM-DD") : "",
      dtFimMandato: form?.getFieldValue("dtFimMandato") ? dayjs(form?.getFieldValue("dtFimMandato")).format("YYYY-MM-DD") : "",
      dtInicioExercicio: form?.getFieldValue("dtInicioExercicio") ? dayjs(form?.getFieldValue("dtInicioExercicio")).format("YYYY-MM-DD") : "",
      dtFimExercicio: form?.getFieldValue("dtFimExercicio") ? dayjs(form?.getFieldValue("dtFimExercicio")).format("YYYY-MM-DD") : "",
      csCondicaoMandato: valueCondicao,
      csRepresentacao: valueRepresentacao,
      prorrogacao: form.getFieldValue("checkProrrogacao") || false,
      reconducao: form.getFieldValue("checkReconducao") || false,
      statusReg: 1,
      mandatoCaracteristicas: mandatoCaracteristicas.map((e: IMandatoCaracteristica) => {
        return {
          ...e
        };
      }),
      mandatoSuspensoes: mandatoSuspensoes.map((e: IMandatoSuspensao) => {
        return {
          ...e
        };
      }),
      habilitacoes: mandatoHabilitacao.map((e: IMandatoHabilitacao) => {
        return {
          ...e
        };
      }),
      mandatoDocumentos: mandatoDocumentos.map((e: IDocumentoMandato) => {
        return {
          ...e
        };
      }),

    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.put(`/mandatoconselheiro/${form?.getFieldValue("idMandato")}`, json).then((response) => {
      setLoading(false);
      resetForm();
      successMessage(
        `Conselheiro ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) atualizado com Sucesso`
      );

      setManter(2) // VOLTA AO ESTADO INICIAL

      form.setFieldsValue({
        "matriculaEfpc": response.data.entidade.matricula ? response.data.entidade.matricula : form?.getFieldValue("matriculaEfpc"),
        "sigla": response.data.entidade.sigla ? response.data.entidade.sigla : form?.getFieldValue("sigla"),
        "nuCpf": response.data.pessoaFisica.nuCpf ? response.data.pessoaFisica.nuCpf : form?.getFieldValue("nuCpf"),
        "nmPessoaFisica": response.data.pessoaFisica.nmPessoaFisica ? response.data.pessoaFisica.nmPessoaFisica : form?.getFieldValue("nmPessoaFisica"),
      });

      getConselheiroPorId(response?.data.idMandato); // Necessário para atualizar os históricos

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });

  };


  const resetForm = () => {
    setLoading(true);
    setMandatoCaracteristicas([]);
    setMandatoSuspensoes([]);
    setMandatoHabilitacao([]);
    setMandatoDocumentos([]);

    setDadosConselheiro(undefined);

    form.setFieldsValue({
      "idMandato": undefined,
      "matriculaEfpc": undefined,
      "nmCargo": undefined,
      "dtInicioMandato": undefined,
      "dtFimMandato": undefined,
      "dtInicioExercicio": undefined,
      "checkProrrogacao": undefined,
      "dtFimExercicio": undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const validarConselheiro = () => {
    // if (!verificaDatas()) {
    //   mostrarInfo("Campos inconsistentes", "A inclusão da data de cancelamento de certificadora exige também a inclusão de uma nova nota técnica");
    // }  else if (!validaDtReconhecimentoCertificadora(form?.getFieldValue("dtReconhecimento"), tipoCertificados)) {
    //   mostrarInfo("Erro na data de reconhecimento da certificadora", "A data de reconhecimento da certificadora não pode ser maior do que uma data de reconhecimento de certificado");
    // } else if (hasDocMandatory(certificadoraDocumentos) !== 1) {
    //   mostrarInfo("Erro em documentos", "Um e apenas um documento dentre 'ESTATUTO' e 'CONTRATO SOCIAL' deve ser incluído");
    //  } else {
    form
      .validateFields([
        "matriculaEfpc",
        "nmCargo",
        "dtInicioMandato",
        "dtFimMandato",
        "dtInicioExercicio",
        "dtFimExercicio",
      ])
      .then(() => {
        sendForm();
      })
      .catch((error) => {
        errorMessage("Campo obrigatório não preechido");
      });
    //  }
  };

  const [ctrlDoc, setCtrlDoc] = useState<ICtrlDoc[]>([]);
  const getCtrlDocCons = async () => {
    let lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,entidade,manter,conselheiro-deliberativo,conselheiro-fiscal,contexto,transacao`;
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDoc(data.content);
  };

  const [caracteristicasMandato, setCaracteristicasMandato] = useState<ICaracteristicasMandato[]>([]);
  const getCaracteristicasMandato = async () => {
    const { data } = await obterCaracteristicasConselheiro();
    setCaracteristicasMandato(data);
  }

  // Add/remove event listener based on `isDirty`
  useEffect(() => {
    const handler = handlerRef.current!;
    if (isDirty) {
      window.addEventListener('beforeunload', handler);
    } else {
      window.removeEventListener('beforeunload', handler);
    }

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [isDirty]);

  return (
    <>
      {/* <Prompt
        when={manter === 3}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}
      <Watermark display={manter === 9 ? "inline" : "none"} />

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title={
            (() => {
              switch (manter) {
                // case 1:
                //   return "Cadastrar Mandato Conselheiro"
                case 2:
                  return "Detalhar Mandato de Conselheiro"
                case 3:
                  return "Alterar Mandato de Conselheiro"
                default:
                  return null
              }
            })()}
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />


        <Card variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            // initialValues={{ remember: false }}
            onFinish={validarConselheiro}
            scrollToFirstError
          >

            <Card title={"Dados Pessoais"}>

              <Row>
                <Col xs={24} xl={8}>
                  <Form.Item label="CPF" name="nuCpf">
                    <Input disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item label="Nome Completo" name="nmPessoaFisica">
                    <Input disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={4} >
                  <Form.Item style={{ alignItems: 'center' }}
                    label="Detalhar Cadastro de Pessoa Física"
                  >
                    <Button
                      // style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INSERIR OU ALTERAR
                      // disabled={props.desabilitaBotoes()}
                      shape='round'
                      onClick={() => {
                        setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                      }}
                      type='primary'
                      icon={<UserOutlined />}
                    />
                  </Form.Item>

                </Col>

              </Row>

              <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }}>
                <>
                  <PessoaFisicaDadosPessoaisComplementares
                    form={form}
                    idPessoaFisica={dadosConselheiro?.pessoaFisica?.idPessoaFisica}
                    mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                  />
                </>
              </Row>

            </Card>

            <Card title={"Dados do Mandato"}>
              <>
                <ConselheiroPerfil
                  form={form}
                  entidades={entidades}
                  manter={manter}
                  setValueCategoria={setValueCategoria}
                  setValueCondicao={setValueCondicao}
                  valueCategoria={valueCategoria}
                  valueCondicao={valueCondicao}
                  setValueRepresentacao={setValueRepresentacao}
                  valueRepresentacao={valueRepresentacao}
                  dadosConselheiro={dadosConselheiro}
                />
              </>
            </Card>

            <Tabs style={{ display: form?.getFieldValue("idMandato") && Number(form?.getFieldValue("idMandato")) !== 0 ? "inline" : "none" }}>
              <Tabs.TabPane tab="Caracteristicas" key="item-1">
                <>
                  <DirigenteCaracteristica
                    form={form}
                    mandatoCaracteristica={mandatoCaracteristicas}
                    setMandatoCaracteristica={setMandatoCaracteristicas}
                    caracteristicasMandato={caracteristicasMandato}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

{/*               <Tabs.TabPane tab="Suspensões" key="item-3">
                <>
                  <DirigenteSuspensao
                    form={form}
                    mandatoSuspensoes={mandatoSuspensoes}
                    setMandatoSuspensoes={setMandatoSuspensoes}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane> */}

              <Tabs.TabPane tab="Habilitação" key="item-4">
                <>
                  <DirigenteHabilitacao
                    form={form}
                    mandatoHabilitacao={mandatoHabilitacao}
                    setMandatoHabilitacao={setMandatoHabilitacao}
                    manter={manter}
                    tipoMandato={2}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Documentação" key="item-5">
                <>
                  <DirigenteDocumento
                    form={form}
                    dirigenteDocumento={mandatoDocumentos}
                    setDirigenteDocumento={setMandatoDocumentos}
                    ctrlDoc={ctrlDoc}
                    manter={manter}
                    csCategoria={dadosConselheiro?.csCategoria}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane disabled={manter !== 2} tab="Histórico" key="item-99" >
                <>
                  <Auditoria
                    dadosAuditoria={dadosAuditoria}
                    setRegistroHistorico={setRegistroHistorico}
                  />
                </>
              </Tabs.TabPane>

            </Tabs>

            <div style={{ display: manter === 9 ? 'inline' : 'none' }}>
              <InfoHistorico form={form} registroHistorico={registroHistorico} />
            </div>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              desabilitaBtnEditar={desabilitaBtnEditar}
              permitirExcluir={hasPermissao([Papel.DILIC_MASTER])}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
              setLoading={setLoading}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Manter;